var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"loading":_vm.loading,"items":_vm.orders,"headers":_vm.headers,"disable-pagination":"","hide-default-footer":"","sort-by":['date'],"sort-desc":[true],"mobile-breakpoint":"0"},scopedSlots:_vm._u([{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":("/orders/" + (item.id))}},[_vm._v(" "+_vm._s(item.id)+" ")])]}},{key:"item.date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("normalDate")(item.date))+" ")]}},{key:"item.total",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(item.total))+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }